import { render, staticRenderFns } from "./bannerList.vue?vue&type=template&id=59610e56&scoped=true"
import script from "./bannerList.vue?vue&type=script&lang=js"
export * from "./bannerList.vue?vue&type=script&lang=js"
import style0 from "./bannerList.vue?vue&type=style&index=0&id=59610e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59610e56",
  null
  
)

export default component.exports